import { gql } from '@apollo/client';

import * as mutations from '../graphql/mutations';
import * as queries from '../graphql/queries';

// Query
export const GET_ALL_APPLIANCES = gql`
  ${queries.getAllAppliances}
`;
export const GET_ALL_ACTIONS = gql`
  ${queries.getAllActions}
`;
export const GET_ALL_ACTIONS_PROPERTIES = gql`
  ${queries.getAllActionsProperties}
`;
export const GET_ALL_CATEGORIES = gql`
  ${queries.getAllCategories}
`;
export const GET_ALL_ACTIONS_MODELS = gql`
  ${queries.getAllActionsModels}
`;
export const GET_ALL_FRACTIONS = gql`
  ${queries.getAllFractions}
`;
export const GET_ALL_INGREDIENTS = gql`
  ${queries.getAllIngredients}
`;
export const GET_ALL_INGREDIENT_CATEGORIES = gql`
  ${queries.getAllIngredientCategories}
`;
export const GET_ALL_INGREDIENT_SECTIONS = gql`
  ${queries.getAllIngredientSections}
`;
export const GET_ALL_PROPERTIES_CHOICES = gql`
  ${queries.getAllPropertiesChoices}
`;
export const GET_PROPERTIES_BY_CODE = gql`
  ${queries.getPropertiesByCode}
`;
export const GET_ALL_RECIPES = gql`
  ${queries.getAllRecipes}
`;
export const GET_RECIPES = gql`
  ${queries.getRecipes}
`;
export const GET_ALL_RECIPE_DEVELOPERS = gql`
  ${queries.getAllRecipeDevelopers}
`;
export const GET_ALL_TAGS = gql`
  ${queries.getAllTags}
`;
export const GET_ALL_TOOLS = gql`
  ${queries.getAllTools}
`;
export const GET_ALL_UNITS = gql`
  ${queries.getAllUnits}
`;
export const GET_ALL_VIDEOS = gql`
  ${queries.getAllVideos}
`;
export const GET_ALL_VIDEO_CATEGORIES = gql`
  ${queries.getAllVideoCategories}
`;
export const GET_ALL_YIELD_TYPES = gql`
  ${queries.getAllYieldTypes}
`;
export const GET_INGREDIENT = gql`
  ${queries.getIngredient}
`;
export const GET_RECIPE = gql`
  ${queries.getRecipe}
`;
export const GET_VIDEO = gql`
  ${queries.getVideo}
`;
export const GET_NOTIFICATION_CATEGORIES = gql`
  ${queries.getNotificationCategories}
`;
export const GET_TEMPERATURE_GUIDES = gql`
  ${queries.getTemperatureGuides}
`;
export const SEARCH_RECIPES = gql`
  ${queries.searchRecipes}
`;

// Mutation
export const ADD_HOWTOS_RECIPE = gql`
  ${mutations.addHowtosRecipe}
`;
export const ADD_INGREDIENT_RECIPE = gql`
  ${mutations.addIngredientRecipe}
`;
export const ADD_INGREDIENT_SECTION_RECIPE = gql`
  ${mutations.addIngredientSectionRecipe}
`;
export const ADD_INGREDIENT_DONENESS = gql`
  ${mutations.createIngredientDoneness}
`;
export const REMOVE_INGREDIENT_DONENESS = gql`
  ${mutations.removeIngredientDoneness}
`;
export const UPDATE_INGREDIENT_DONENESS = gql`
  ${mutations.updateIngredientDoneness}
`;
export const ADD_LINKED_RECIPES = gql`
  ${mutations.addLinkedRecipes}
`;
export const ADD_SECTION_RECIPE = gql`
  ${mutations.addSectionRecipe}
`;
export const ADD_STEP_RECIPE = gql`
  ${mutations.addStepRecipe}
`;
export const ADD_TAGS_RECIPE = gql`
  ${mutations.addTagsRecipe}
`;
export const ADD_TOOLS_RECIPE = gql`
  ${mutations.addToolsRecipe}
`;
export const ADD_VIDEO = gql`
  ${mutations.addVideo}
`;
export const ADD_YIELD_TYPE = gql`
  ${mutations.addYieldType}
`;
export const CREATE_FRACTION = gql`
  ${mutations.createFraction}
`;
export const CREATE_INGREDIENT = gql`
  ${mutations.createIngredient}
`;
export const CREATE_INGREDIENT_CATEGORY = gql`
  ${mutations.createIngredientCategory}
`;
export const CREATE_INGREDIENT_SECTION = gql`
  ${mutations.createIngredientSection}
`;
export const CREATE_RECIPE = gql`
  ${mutations.createRecipe}
`;
export const CREATE_SECTION = gql`
  ${mutations.createSection}
`;
export const CREATE_TAG = gql`
  ${mutations.createTag}
`;
export const CREATE_TOOL = gql`
  ${mutations.createTool}
`;
export const CREATE_UNIT = gql`
  ${mutations.createUnit}
`;
export const REMOVE_HOWTOS_RECIPE = gql`
  ${mutations.removeHowtosRecipe}
`;
export const REMOVE_INGREDIENT = gql`
  ${mutations.removeIngredient}
`;
export const REMOVE_INGREDIENT_RECIPE = gql`
  ${mutations.removeIngredientRecipe}
`;
export const REMOVE_INGREDIENT_SECTION_RECIPE = gql`
  ${mutations.removeIngredientSectionRecipe}
`;
export const REMOVE_LINKED_RECIPES = gql`
  ${mutations.removeLinkedRecipes}
`;
export const REMOVE_SECTION_RECIPE = gql`
  ${mutations.removeSectionRecipe}
`;
export const REMOVE_STEP_RECIPE = gql`
  ${mutations.removeStepRecipe}
`;
export const REMOVE_TAGS_RECIPE = gql`
  ${mutations.removeTagsRecipe}
`;
export const REMOVE_TOOLS_RECIPE = gql`
  ${mutations.removeToolsRecipe}
`;
export const REPLACE_INGREDIENT = gql`
  ${mutations.replaceIngredient}
`;
export const REPLACE_STEP_RECIPE = gql`
  ${mutations.replaceStepRecipe}
`;
export const UPDATE_INGREDIENT = gql`
  ${mutations.updateIngredient}
`;
export const UPDATE_INGREDIENT_RECIPE = gql`
  ${mutations.updateIngredientRecipe}
`;
export const UPDATE_INGREDIENT_SECTION_RECIPE = gql`
  ${mutations.updateIngredientSectionRecipe}
`;
export const UPDATE_RECIPE = gql`
  ${mutations.updateRecipe}
`;
export const UPDATE_SECTION_RECIPE = gql`
  ${mutations.updateSectionRecipe}
`;
export const UPDATE_STEP_RECIPE = gql`
  ${mutations.updateStepRecipe}
`;
export const UPDATE_VIDEO = gql`
  ${mutations.updateVideo}
`;
export const VERSION_RECIPE = gql`
  ${mutations.versionRecipe}
`;

export const ADD_TICKET_ACTION = gql`
  ${mutations.addTicketAction}
`;

export const GET_TICKETS = gql`
  ${queries.getTickets}
`;
export const GET_TICKET = gql`
  ${queries.getTicket}
`;
export const GET_RELATED_TICKETS = gql`
  ${queries.getRelatedTickets}
`;
export const GET_COMMENT_THREAD = gql`
  ${queries.getCommentThread}
`;
export const GET_MODERATION_PROFILE = gql`
  ${queries.getModerationProfile}
`;
export const GET_USER_COMMENTS = gql`
  ${queries.getUserComments}
`;
export const GET_USER_FLAGGED_TICKETS = gql`
  ${queries.getUserFlaggedTickets}
`;
export const GET_USER_REPORTS = gql`
  ${queries.getUserReports}
`;
export const ADD_MODEL_RECIPE = gql`
  ${mutations.addModelRecipe}
`;
export const REMOVE_MODEL_RECIPE = gql`
  ${mutations.removeModelRecipe}
`;
export const GET_SECTION_RECIPE_MODELS = gql`
  ${queries.getSectionRecipeModels}
`;
export const ADD_MODEL_SECTION_RECIPE = gql`
  ${mutations.addModelSectionRecipe}
`;
export const REMOVE_MODEL_SECTION_RECIPE = gql`
  ${mutations.removeModelSectionRecipe}
`;

export const ADMIN_GET_PROFILES = gql`
  ${queries.adminGetProfiles}
`;

export const ADD_PROFILES_RECIPE = gql`
  ${mutations.addProfilesRecipe}
`;

export const REMOVE_PROFILES_RECIPE = gql`
  ${mutations.removeProfileRecipe}
`;

export const SEARCH_INGREDIENTS = gql`
  ${queries.searchIngredients}
`;

export const SEARCH_INGREDIENTS_SUGGEST = gql`
  ${queries.searchIngredientsSuggest}
`;

export const GET_MODELS = gql`
  ${queries.getModels}
`;

export const GET_SECTIONS = gql`
  ${queries.getSections}
`;

export const GET_CONDITIONS_MODELS = gql`
  ${queries.getConditionsModels}
`;

export const GET_PROPERTIES_CHOICES = gql`
 ${queries.getPropertiesChoices}
`;

export const GET_ACTIONS_MODELS = gql`
  ${queries.getActionsModels}
`;

export const GET_ACTIONS_PROPERTIES = gql`
  ${queries.getActionsProperties}
`;

export const ADD_SECTION_RECIPE_ACTION = gql`
  ${mutations.addSectionRecipeAction}
`;

export const UPDATE_SECTION_RECIPE_ACTION = gql`
  ${mutations.updateSectionRecipeAction}
`;

export const REMOVE_SECTION_RECIPE_ACTION = gql`
  ${mutations.removeSectionRecipeAction}
`;

export const ADD_SECTION_RECIPE_CONDITION = gql`
  ${mutations.addSectionRecipeCondition}
`;

export const UPDATE_SECTION_RECIPE_CONDITION = gql`
  ${mutations.updateSectionRecipeCondition}
`;

export const REMOVE_SECTION_RECIPE_CONDITION = gql`
  ${mutations.removeSectionRecipeCondition}
`;

export const ADD_STEP_ACTION = gql`
  ${mutations.addStepAction}
`;

export const UPDATE_STEP_ACTION = gql`
  ${mutations.updateStepAction}
`;

export const REMOVE_STEP_ACTION = gql`
  ${mutations.removeStepAction}
`;

export const ADD_STEP_CONDITION = gql`
  ${mutations.addStepCondition}
`;

export const UPDATE_STEP_CONDITION = gql`
  ${mutations.updateStepCondition}
`;

export const REMOVE_STEP_CONDITION = gql`
  ${mutations.removeStepCondition}
`;

export const GET_ACTIONS = gql`
  ${queries.getActions}
`;

export const GET_CHOICES = gql`
  ${queries.getChoices}
`;

export const GET_PROBE_BY_ADDRESS = gql`
  ${queries.getProbeByAddress}
`;